// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_TOPIC_EDIT = "Uprav popis a fotku";
export const SEO_TITLE_FORUM_TOPIC_INFO_category = "O kateg\u00f3rii %(category)s";
export const SEO_TITLE_FORUM_TOPICS = "Diskusie o v\u0161etkom, \u010do \u017eivot prin\u00e1\u0161a";
